<template>
  <div>
    <v-sheet
      class="adminPanelActivator"
      color="res"
      elevation="1"
      height="30"
      width="30"
      @dblclick="dialog = true"
    ></v-sheet>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="">
          Vilket läge av Livet i havet vill du använda?
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="clientMode">
            <v-radio label="Normalt läge" value="normal"></v-radio>
            <v-radio label="Utställningsläge" value="kiosk"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeAndReload">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminPanel',
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    clientMode: {
      get() {
        return this.$store.getters.getClientMode
      },
      set(val) {
        localStorage.clientMode = val
      }
    }
  },
  methods: {
    closeAndReload() {
      this.dialog = false
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.adminPanelActivator {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999;
  opacity: 0;
}
</style>
